var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('div',{staticClass:"flex border_main4 items-center"},[_c('div',{staticClass:"item_img flex justify-center"},[_c('div',{staticClass:"rounded-full"},[_c('div',{staticClass:"record_img"},[_c('canvas',{ref:"recordRef",staticClass:"canvas canvas_Recognition",attrs:{"id":"canvas"}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }